
import { Link } from "react-router-dom";

interface LinkedStartupProps {
  startup: {
    id: string;
    name: string;
    banner_url?: string;
    short_description?: string;
  };
}

export const LinkedStartup = ({ startup }: LinkedStartupProps) => {
  return (
    <div className="border-t border-flux-cyan/10 pt-3 -mx-3 sm:-mx-4 px-3 sm:px-4">
      <Link 
        to={`/communities/startups/${startup.id}`}
        className="block p-2.5 rounded-lg bg-black/20 hover:bg-black/30 transition-colors"
      >
        <div className="flex items-start gap-3">
          {startup.banner_url ? (
            <img 
              src={startup.banner_url} 
              alt={startup.name}
              className="w-14 h-14 object-cover rounded"
            />
          ) : (
            <div className="w-14 h-14 bg-flux-cyan/10 rounded flex items-center justify-center">
              <span className="text-flux-cyan/50 text-lg font-medium">
                {startup.name.charAt(0)}
              </span>
            </div>
          )}
          <div className="flex-1 min-w-0">
            <h3 className="font-medium text-flux-cyan truncate text-sm">
              {startup.name}
            </h3>
            {startup.short_description && (
              <p className="text-xs text-gray-400 line-clamp-2">
                {startup.short_description}
              </p>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};
